<template lang="pug">
#modal-confirmar-inicio-analise-operacao
    el-dialog(
        title='Confirmar início da análise',
        width='610px',
        :visible='show',
        @close='closeDialog()'
    )
        h4.mb-4 Atenção. Após iniciar a análise o cadastrante não poderá mais realizar edições na operação. Deseja continuar?
        p
            b Identificador da operação:
            |
            | {{ operacao.identificador }}

        .buttons.d-flex.justify-content-between
            el-button(size='mini', @click='closeDialog()')
                | Fechar
            el-button(
                type='primary',
                size='mini',
                @click='alterarStatusParaEmAnalise'
            )
                | Iniciar Análise
</template>

<script>
import StatusOperacao from '@/constants/StatusOperacao.js';
import OperacaoService from '@/services/OperacaoService.js';

export default {
    name: 'ModalConfirmarInicioAnaliseOperacao',

    emits: ['iniciarAnalise'],

    props: {
        operacao: {
            type: Object,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        }
    },

    methods: {
        closeDialog() {
            this.$emit('update:show', false);
        },

        async alterarStatusParaEmAnalise() {
            const analiseOperacao = {
                idOperacao: this.operacao.id,
                idStatusOperacao: StatusOperacao.EM_ANALISE,
                parecer: null
            };

            await OperacaoService.atualizarStatus(analiseOperacao)
                .then(() => {
                    this.$emit('iniciarAnalise');
                })
                .catch(error => {
                    this.$notify.error({
                        message:
                            'Não foi possivel iniciar a analise da operação.'
                    });
                    throw error;
                })
                .finally(() => {
                    this.closeDialog();
                });
        }
    }
};
</script>

<style lang="scss">
#modal-confirmar-inicio-analise-operacao {
    .center-align {
        text-align: center;
    }

    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }

    .mapa {
        height: 150px;
        border-radius: 4px;
        overflow: hidden;
        margin: -20px 0 20px 0;
    }

    .link {
        margin-left: 20px;
        cursor: pointer;

        i {
            display: inline-flex;
            vertical-align: bottom;
            font-style: normal;
            font-size: 13px;
        }
    }

    .margin-p {
        margin-bottom: 0;
    }
}
</style>
